// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from '../../../LEGACY/elemental'
import AnimateHeight from 'react-animate-height'

export default function ErrorBox({ errors, style }) {
  const hasErrors = errors && errors.length
  return (
    <AnimateHeight
      animateOpacity
      duration={200}
      height={hasErrors ? 'auto' : 0}
    >
      <Alert key="error" color="danger" style={style}>
        {hasErrors && errors.map((err, i) => <div key={i}>{String(err)}</div>)}
      </Alert>
    </AnimateHeight>
  )
}

ErrorBox.propTypes = {
  errors: PropTypes.array,
  style: PropTypes.object,
}
